import type { MomentView } from '../types'

// ============================================================
// 集中組分享連結 — Home / ShareModal 共用，確保前後一致
// ------------------------------------------------------------
// 站內深層連結：/<分類 slug>?m=<moment id>
//   打開後跳過 intro、捲動到該卡片實際位置、自動播放（先 muted）。
//   一律用 moment 自己的分類 slug（不受當前 filter / 吸睛度影響），
//   確保接收端那一格 lane 一定載得到這張卡。
// ============================================================
export function buildShareUrl(moment: MomentView): string {
  const slug = moment.category?.slug ?? ''
  const params = new URLSearchParams({ m: moment.id })
  return `${window.location.origin}/${slug}?${params.toString()}`
}

/** YouTube 原片連結（帶起始秒）— 給人複製去別處 */
export function buildYouTubeUrl(moment: MomentView): string {
  return `https://youtu.be/${moment.youtubeId}?t=${moment.startSeconds}`
}

/**
 * 音樂時光分享連結：/?play=<seed>&from=<point|start>
 * 對方打開後用同一個 seed 對歌單重現相同洗牌順序、自動連播。
 * 用 root 路徑 + query，避免 useCategoryUrl 正規化路徑時把 query 弄丟。
 */
export function buildPlayerShareUrl(seed: number, fromStart: boolean): string {
  const params = new URLSearchParams({ play: String(seed), from: fromStart ? 'start' : 'point' })
  return `${window.location.origin}/?${params.toString()}`
}
